// extracted by mini-css-extract-plugin
export default {"close":"styles_close__Gqxoj","icon":"styles_icon__GM6hL"};